const positionSelectionDialog = {
  "position.selection.dialog.title": "Selecciona tu posición",
  "position.selection.dialog.actions.random": "Posiciones Aleatorias",
};

const positionSelectionLabels = {
  "position.selection.random.positions": "Posiciones Aleatorias",
  "position.selection.multiple.positions": "Múltiples posiciones",
  "position.selection.all.phases": "Todas las Fases",
  "position.selection.multiple.phases": "Múltiples Fases",
  "position.selection.select.phases": "Seleccionar Fases",
  "position.selection.select.all.phases": "Seleccionar Todo",
  "position.selection.clear.all.phases": "Limpiar Todo",
};

export const positionSelection = {
  ...positionSelectionDialog,
  ...positionSelectionLabels,
};
